import { asReadonlyBS, createSetterBS } from '@ocodelib/ex-util/rx';
import { BehaviorSubject } from 'rxjs';
import type { IPyBasicLayoutConfig } from './types';

export class UiState {
  #currentContentTab$ = new BehaviorSubject<string | null>(null);
  #contentTabs$ = new BehaviorSubject<string[]>([]);

  /**
   * 프리뷰 모드 여부
   * 갤러리 상세보기는 프리뷰 모드로 동작합니다.
   * 프리뷰모드에서는 Topbar나 탭부분의 UI를 감춰야 합니다.
   * 선택된 탭의 내용을 감추는 것이 아닙니다.
   * 프리뷰모드에서도 프로그래밍적으로 탭선택은 가능합니다.
   */
  #previewMode$ = new BehaviorSubject(false);

  setCurrentContentTab = createSetterBS(this.#currentContentTab$);
  currentContentTab$ = asReadonlyBS(this.#currentContentTab$);

  setContentTabs = createSetterBS(this.#contentTabs$);
  contentTabs$ = asReadonlyBS(this.#contentTabs$);

  setPreviewMode = createSetterBS(this.#previewMode$);
  previewMode$ = asReadonlyBS(this.#previewMode$);

  updateFromConfig(config: IPyBasicLayoutConfig) {
    const contentTabsConfig = config.contentTabs;
    const tabKeys = contentTabsConfig.tabs.map((it) => it.key);
    let initialTab = contentTabsConfig.initaialTabKey;
    if (!initialTab && tabKeys.length > 0) {
      initialTab = tabKeys[0];
    }
    this.#contentTabs$.next(tabKeys);
    this.#currentContentTab$.next(initialTab ?? null);
  }
}
